import { Component, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { SwitcherService } from 'src/app/shared/services/switcher.service';
import { Menu } from '../../services/nav.service';
import { localStorageBackUp } from '../../componets/switcher/switcher';

@Component({
    selector: 'app-full-layout',
    templateUrl: './full-layout.component.html',
    styleUrls: ['./full-layout.component.scss'],
    standalone: false
})
export class FullLayoutComponent implements OnInit {
  public menuItems!: Menu[];
  isMenuOpen: any;

  constructor(
    public SwitcherService: SwitcherService,
    private el: ElementRef,
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {
    localStorageBackUp()
  }
  // app-notification-sidebar

  ngOnInit(): void {}

  mainSidebarOpen: any;
  hoverEffect($event: any) {
    this.mainSidebarOpen =
      $event.type == 'mouseover' ? 'sidenav-toggled-open' : '';
  }

  menuItem = {
    active: false,
  };

  BodyClick() {    
    this.SwitcherService.emitChange(false);

    const switcher = this.el.nativeElement.querySelector('.switcher');
    if (switcher) {
      this.renderer.removeClass(switcher, 'show');
      document.querySelector('#responsive-overlay')?.classList.add('active');
    } else {
        this.renderer.addClass('data-toggle', 'close');
       document.querySelector('#responsive-overlay')?.classList.remove('active');
    }
    const sidebar = this.el.nativeElement.querySelector('.sidebar ');
    if (sidebar) {
      this.renderer.removeClass(sidebar, 'show');
    }
    document.querySelector('#responsive-overlay')?.classList.remove('active');
    let html = this.elementRef.nativeElement.ownerDocument.documentElement;
    if (window.innerWidth <= 992) {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'close' ? 'close' : 'close'
      );
    }

    this.menuItem.active = !this.menuItem.active;
  }

  clearToggle() {
    document.querySelector('#responsive-overlay')?.classList.remove('active');
    let html = this.elementRef.nativeElement.ownerDocument.documentElement;
    html?.setAttribute('data-toggled', 'open');
  }

  ngOnDestroy() {
    const windowObject: any = window;
    let html = this.elementRef.nativeElement.ownerDocument.documentElement;
    if (windowObject.innerWidth == '992') {
      html?.removeAttribute('data-toggled');
    }
   
  }

  closeMenu() {
    this.menuItems?.forEach((a: any) => {
      if (this.menuItems) {
        a.active = false;
      }
      a?.children?.forEach((b: any) => {
        if (a.children) {
          b.active = false;
        }
      });
    });
  }

  scrolled: boolean = false;

  @HostListener('window:resize', [])
  onWindowScroll() {
    this.scrolled = window.matchMedia('(max-width: 991.98px)').matches;
  }
}
